import { render, staticRenderFns } from "./SelectedProducts.vue?vue&type=template&id=ff153f2a&"
import script from "./SelectedProducts.vue?vue&type=script&lang=js&"
export * from "./SelectedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports